import React, { useContext, useRef, useState } from "react";
import { Formik, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { ProfileSection } from "../../context/ProfileContext";
import { withRouter } from "react-router-dom";
import { changePassword } from "../../api";
import Cookies from "js-cookie";
import { Alert } from "../";
import { useTranslation } from "react-i18next";
const ChangePasswordComp = (props) => {
  const { t } = useTranslation();
  const token = Cookies.get("token");
  const form = useRef(null);
  const { ProfileShowHideFunc } = useContext(ProfileSection);
  const [showAlert, setShowAlert] = useState({
    show: false,
    message: "",
    type: "",
  });

  const initialChangePassworValues = {
    current_password: "",
    new_password: "",
    confirmPass: "",
  };

  const submitChangePasswordForm = () => {
    const formData = new FormData(form.current);
    changePassword(formData, token)
      .then((res) => {
        if (res.data.message === "OK") {
          setShowAlert((prevState) => ({
            ...prevState,
            show: true,
            message: t("رمز جدید با موفقیت ثبت شد."),
            type: "Success",
          }));
          setTimeout(() => {
            ProfileShowHideFunc("firstPage");
          }, 3000);
        } else {
          setShowAlert((prevState) => ({
            ...prevState,
            show: true,
            message: res.data.message_dialect,
            type: "Error",
          }));
          setTimeout(() => {
            setShowAlert((prevState) => ({
              ...prevState,
              show: false,
            }));
          }, 3000);
        }
      })
      .catch((err) => {
        if (err.response.status === 403) {
          Cookies.remove("token");
          props.history.push("/login");
          setShowAlert((prevState) => ({
            ...prevState,
            show: true,
            message: t("خطایی رخ داده است . لطفا مجددا امتحان کنید."),
            type: "Error",
          }));
          setTimeout(() => {
            setShowAlert((prevState) => ({
              ...prevState,
              show: false,
            }));
          }, 2000);
        }
      });
  };

  const validationSchemaChangePassword = Yup.object({
    current_password: Yup.string().required(t("رمز عبور را وارد کنید.")),
    new_password: Yup.string().required(t("رمز عبور جدید را وارد کنید.")),
    confirmPass: Yup.string()
      .required(t("رمز عبور جدید را وارد کنید."))
      .oneOf([Yup.ref("new_password"), null], t()),
  });

  return (
    <>
      <div
        className="bg-white text-right fn12 mx-auto my-5 py-4 px-3 cursor"
        style={{ width: "90%", color: "#FF3900" }}
        onClick={() => props.history.push("/forgotpassword")}
      >
        <a>{t("فراموشی رمز عبور")}</a>
      </div>
      <Formik
        initialValues={initialChangePassworValues}
        onSubmit={submitChangePasswordForm}
        validationSchema={validationSchemaChangePassword}
      >
        {(props) => (
          <Form ref={form}>
            <div style={{ height: "47vh" }}>
              <div className="editInputs d-flex flex-column justify-content-center m-auto px-3 pb-2 pt-4">
                {props.values.current_password && (
                  <p className="fn12 m-0 text-right">{t("رمز عبور")}</p>
                )}
                <input
                  type="password"
                  placeholder={t("رمز عبور")}
                  name="current_password"
                  className="w-100 fn12"
                  onChange={props.handleChange}
                  onBlur={props.handleBlur}
                />
              </div>
              <ErrorMessage name="current_password">
                {(errMsg) => (
                  <div className="text-danger fn10 mt-1 mr-4 text-right">
                    {errMsg}
                  </div>
                )}
              </ErrorMessage>
              <div className="editInputs d-flex flex-column justify-content-center m-auto px-3 py-2">
                {props.values.new_password && (
                  <p className="fn12 m-0 text-right">{t("رمز عبور جدید")}</p>
                )}
                <input
                  type="password"
                  placeholder={t("رمز عبور جدید")}
                  name="new_password"
                  className="w-100 fn12"
                  onChange={props.handleChange}
                  onBlur={props.handleBlur}
                />
              </div>
              <ErrorMessage name="new_password">
                {(errMsg) => (
                  <div className="text-danger fn10 mt-1 mr-4 text-right">
                    {errMsg}
                  </div>
                )}
              </ErrorMessage>
              <div className="editInputs d-flex flex-column justify-content-center m-auto px-3 py-2">
                {props.values.confirmPass && (
                  <p className="fn12 m-0 text-right">
                    {t("تکرار رمز عبور جدید")}
                  </p>
                )}
                <input
                  type="password"
                  placeholder={t("تکرار رمز عبور جدید")}
                  name="confirmPass"
                  className="w-100 fn12"
                  onChange={props.handleChange}
                  onBlur={props.handleBlur}
                />
              </div>
              <ErrorMessage name="confirmPass">
                {(errMsg) => (
                  <div className="text-danger fn10 mt-1 mr-4 text-right">
                    {errMsg}
                  </div>
                )}
              </ErrorMessage>
            </div>
            <div className="d-flex flex-wrap justify-content-center mt-4">
              <button
                type="submit"
                className="border-0 bg-transparent mx-3 d-flex justify-content-center align-items-center flex-column text-center"
              >
                <span className="profileAddUser bg-white d-block icon-ok cursor"></span>
                <small className="fn12 mt-1">{t("ذخیره")}</small>
              </button>
              <div
                className="mx-3 d-flex justify-content-center align-items-center flex-column text-center"
                onClick={() => ProfileShowHideFunc("setting")}
              >
                <span className="profileAddUser bg-white d-block icon-left-1 cursor"></span>
                <small className="fn12 mt-1">{t("بازگشت")}</small>
              </div>
            </div>
          </Form>
        )}
      </Formik>
      {showAlert.show && (
        <Alert message={showAlert.message} type={showAlert.type} />
      )}
    </>
  );
};

const ChangePassword = withRouter(ChangePasswordComp);

export { ChangePassword };
